import { db, auth } from "./index";
import { collection, addDoc, serverTimestamp, doc } from "firebase/firestore";

/**
 * Handles user requests for content access or notifications
 * @param {string} contentId - Database ID of the content (e.g., "theFilmProjects")
 * @param {string} contentTitle - Display name of content (e.g., "The Film Projects")
 * @param {string} userRole - The user's role ('admin', 'vip', or 'visitor')
 * @returns {Promise<boolean>} - Whether the request was successful
 */
export async function requestContentAccess(contentId, contentTitle, userRole) {
  try {
    if (!auth.currentUser) {
      return false;
    }

    // Determine request type based on user role
    const requestType = userRole === "vip" ? "notification" : "access";

    // Add to subcollection instead of updating fields
    const userRef = doc(db, "users", auth.currentUser.uid);
    const requestsRef = collection(userRef, "content_requests");
    await addDoc(requestsRef, {
      content_id: contentId,
      request_type: requestType,
      requested_at: serverTimestamp(),
      status: "pending",
      notification_sent: false,
    });

    // Send email to admin
    const response = await fetch(
      "https://us-central1-the33path.cloudfunctions.net/sendEmailOnRequest",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: auth.currentUser.displayName || auth.currentUser.email,
          email: auth.currentUser.email,
          requestType: requestType,
          contentTitle: contentTitle,
          // Set appropriate email subject based on request type
          subject: requestType === "notification"
            ? `Content Availability Notification Request - ${contentTitle}`
            : `Content Access Request - ${contentTitle}`,
          message:
            requestType === "notification"
              ? `VIP user has requested to be notified when "${contentTitle}" becomes available.`
              : `User has requested access to "${contentTitle}".`,
        }),
      }
    );

    if (!response.ok) {
      console.warn("Email notification failed, but database request was saved");
    }

    return true;
  } catch (error) {
    return false;
  }
}
